import apiEndPoints from "../../routeConfig";
import { ApiService } from "../../../service/api.service";

const apiService = new ApiService();

export const countryManagementCreateOrUpdate = async (data, editMode, id,) => {
  let url
  let result
  if (editMode === true) {
    url = `${apiEndPoints.countryManagementCreateOrUpdate}/${id}`
  } else {
    url = `${apiEndPoints.countryManagementCreateOrUpdate}`
  }
  if (editMode === true) {
    await apiService.update(url, data).then(response => {
      result = response;
    }).catch(error => {
      result = error;
    })
  } else {
    await apiService.post(url, data).then(response => {
      result = response;
    }).catch(error => {
      result = error;
    })
  }
  return result;
}

export const getAllcountryManagement = async (page = 0, limit = 10) => {
  try {
    const response = await apiService.get(`${apiEndPoints.getAllcountryManagement}?page=${page + 1}&limit=${limit}`,);
    return response.data;
  } catch (error) {
    return error;
  }
};

export const countryManagementGetById = async (id) => {
  let result;
  await apiService.get(`${apiEndPoints.countryManagementGetById}/${id}`)
    .then((response) => {
      result = response.data;
    })
    .catch(error => {
      result = error;
    });
  return result;
};

export const deleteCountryManagement = async (id) => {
  try {
    const response = await apiService.patch(`${apiEndPoints.deleteCountryManagement}/${id}/status/DELETED`, '');
    return response;
  } catch (error) {
    return error;
  }
};

export const countryManagementMetaData = async (id,editMode) => {
  let result;
  let url;
  if(editMode){
    url = `${apiEndPoints.countryManagementMetaData}?id=${id}`;
  }else{
    url = `${apiEndPoints.countryManagementMetaData}`;

  }
  await apiService.get(url)
    .then((response) => {
      result = response.data;
    })
    .catch(error => {
      result = error;
    });
  return result;
};